import { FIRST_SKINCARE_QUESTION_ROUTE } from 'Apps/Consultation/constants';

import heroImgDesktop from 'assets/images/productPages/d-skincare-collection-hero.png';
import heroImgMobile from 'assets/images/productPages/m-skincare-collection-hero.jpg';
import haircareImgDesktop from 'assets/images/productPages/prose-model-showering-desktop.jpg';
import haircareImgMobile from 'assets/images/productPages/prose-model-showering-mobile.jpg';
import skincareImgDesktop from 'assets/images/productPages/prose-model-using-custom-skincare-desktop-skincare-plp.jpg';
import skincareImgMobile from 'assets/images/productPages/prose-model-using-custom-skincare-mobile-skincare-plp.jpg';

export const skincareCollection = {
  hero: {
    imageDesktop: heroImgDesktop,
    imageMobile: heroImgMobile,
    imageTablet: heroImgDesktop,
    color: 'noir',
    headline: 'Custom skincare',
    consultationCta: {
      hasNotStartedConsultation: {
        dataClick: 'consultation-skincare',
        dataFrom: 'plp-hero',
        label: 'Get your formula',
        url: FIRST_SKINCARE_QUESTION_ROUTE,
      },
      hasStartedConsultation: {
        dataClick: 'finish-consultation-skincare',
        dataFrom: 'plp-hero',
        label: 'Finish your consultation',
        url: FIRST_SKINCARE_QUESTION_ROUTE,
      },
      hasCompletedConsultation: {
        dataClick: 'skincare-cart',
        dataFrom: 'plp-hero',
        label: 'Order your Prose',
        url: '/checkout/skincare',
      },
    },
  },
  seoBlurb: {
    headline: 'Three simple steps, one powerful routine',
    subHead:
      'Developed with dermatologists to bring out your healthiest skin, Prose custom skincare is bottled fresh, made to order, and personalized to 85+ factors from your in-depth consultation. Formulated with a unique blend of naturally powerful and clinically proven ingredients, your personalized skincare routine couldn’t exist without you.',
  },
  featured: [
    {
      dataClick: 'PLP-upsell',
      dataFrom: 'explore-skincare',
      imgAlt: 'Prose model using custom skincare',
      imgMobile: skincareImgMobile,
      imgDesktop: skincareImgDesktop,
      title: 'Discover custom skincare',
      ctaLabel: 'explore skincare',
      url: '/pages/skincare',
    },
    {
      dataClick: 'PLP-upsell',
      dataFrom: 'explore-haircare',
      imgAlt: 'Prose model showering with custom haircare',
      imgMobile: haircareImgMobile,
      imgDesktop: haircareImgDesktop,
      title: 'Browse custom haircare',
      ctaLabel: 'shop haircare',
      url: '/products/haircare',
    },
  ],
};
